import {computed} from 'vue'
import {useUserStore} from '@/stores/user'

export function useLanguageMapping<T>(mapping: Record<string, T>, fallbackLanguage = 'en') {
  const userStore = useUserStore()

  return computed(() => mapping[userStore.language] ?? mapping[fallbackLanguage])
}
